import { useaxios } from "../../../utils/useaxios";
export default (text) => recaller => setrecaller => items => setitems => setbarcode => invoice_item => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    if (invoice_item.find((lis) => lis.item_barcode == text)) {
        if (items.find((lis) => lis.item_barcode == text)) {
            // if()
            setitems(items.map((lis) => lis.item_barcode == text ? { item_id: lis.item_id, item_name: lis.item_name, item_barcode: lis.item_barcode, item_sell_price: lis.item_sell_price, item_return_price: lis.item_return_price, item_qty: Number(lis.item_qty) + 1 } : lis));
        } else {
            var itm = invoice_item.filter((lis) => lis.item_barcode == text);
            setitems([...items, { item_id: itm[0].item_id, item_name: itm[0].item_name, item_barcode: itm[0].item_barcode, item_sell_price: itm[0].item_sell_price, item_return_price: itm[0].item_sell_price, item_qty: 1 }]);
        }
        setbarcode('');
    } else {
        window.alert('لەم وەسڵە ئەم کاڵایە نییە');
        setbarcode('');
    }
    // useaxios('item/getitem.php', { text }).then((res) => {
    //     setbarcode('');
    //     if (res.status == "ok") {
    //         if (invoice_item.find((lis) => lis.item_id == res.data[0].item_id)) {
    //         if (items.find((lis) => lis.item_id == res.data[0].item_id)) {
    //             setitems(items.map((lis) => lis.item_id == res.data[0].item_id ? { item_id: lis.item_id, item_name: lis.item_name, item_barcode: lis.item_barcode, item_price: lis.item_price, item_sell_price: lis.item_sell_price, item_qty: Number(lis.item_qty) + 1, item_quantity: lis.item_quantity } : lis));
    //         }else{
    //             setitems([...items, { item_id: res.data[0].item_id, item_name: res.data[0].item_name, item_barcode: res.data[0].item_barcode, item_price: res.data[0].item_price, item_sell_price: res.data[0].item_price, item_qty: 1, item_quantity: res.data[0].item_qty }]);
    //         }
    //         } else {
    //             window.alert('لەم وەسڵە ئەم کاڵایە نییە');
    //         }
    //     } else {
    //         window.alert('هیچ کاڵایەک نەدۆزرایەوە');
    //     }
    // });
}